import React from 'react';
import { XCircleIcon } from 'lucide-react';
import { Card } from '../ui/Card';
export function WhyFailedSection() {
  const failures = [{
    title: 'Dietas de 1,200 calorías',
    description: 'Bajan tu tasa metabólica, haciendo que recuperes el doble de peso al terminar.'
  }, {
    title: 'Cardio intenso',
    description: 'Eleva el cortisol nocturno, impidiendo que tu cuerpo use la grasa como energía mientras duermes.'
  }, {
    title: 'Batidos sustitutos',
    description: 'No regulan tus estrógenos, dejando la raíz del problema hormonal intacta.'
  }, {
    title: 'Saltarte la cena',
    description: 'Provoca picos de glucosa que te despiertan a las 3:00 a.m. con ansiedad.'
  }];
  return <section className="py-20 bg-beige-light" data-id="element-228">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-229">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-230">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-231">
            ¿Por qué lo que intentaste no funcionó?
          </h2>
          <p className="text-lg font-body text-taupe-light" data-id="element-232">
            La industria del fitness te ha mentido. Las estrategias
            tradicionales están diseñadas para cuerpos de 20 años, no para la
            complejidad hormonal de una mujer madura.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6 lg:gap-8" data-id="element-233">
          {failures.map((item, index) => <Card key={index} className="p-6 md:p-8 flex gap-4 items-start hover:shadow-md transition-shadow" data-id="element-234">
              <XCircleIcon className="w-8 h-8 text-rose flex-shrink-0 mt-1" data-id="element-235" />
              <div data-id="element-236">
                <h3 className="font-heading text-xl font-bold text-taupe mb-2" data-id="element-237">
                  {item.title}
                </h3>
                <p className="font-body text-taupe-light leading-relaxed" data-id="element-238">
                  {item.description}
                </p>
              </div>
            </Card>)}
        </div>
      </div>
    </section>;
}